import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { ACTIONS, APIS, STORAGE } from '../../_config'
import moment from 'moment';
//import { CallApi, responseHandler } from '../api/callApi';
//import { UpdateWithVariables } from '../../_common/functions';
// const API_BASE_URL = process.env.REACT_APP_API_URL;


export function* loginUser(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.LOGIN, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            if (resp?.data.data?.access_token) {
                localStorage.setItem(STORAGE, JSON.stringify(resp.data.data));
                // localStorage.setItem('loginTimestamp', moment().format());
                yield put({
                    type: ACTIONS.USER.LOGIN,
                    payload: {
                        accessToken: resp.data.data.access_token,
                        refreshToken: resp.data.data.access_token,
                        isAuthenticated: true,
                    }
                })
            }
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}
export function* register(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.REGISTRATION, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}
export function* forgotPassword(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.FORGOT_PASSWORD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* resetPassword(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.RESET_PASSWORD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* logout(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.LOGOUT, data);
        if(resp.message){
            localStorage.removeItem(STORAGE);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        }else{
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}


/* export function* login(action: any): any {
    action.callbackSuccess({});
}
export function* logout(action: any): any {
    action.callbackSuccess({});
} */

/* export function* restPassword(action: any): any {
    try {
        const data = action.payload;
        let API = UpdateWithVariables(API_URL.USER.RESET_PASSWORD, data.urlParams)
        if (data.urlParams) {
            delete data.urlParams
        }
        const resp = yield call(CallApi.POST, API, data, true);
        let respChecker = responseHandler(resp)
        if (respChecker.status) {
            action && action.callbackSuccess && action.callbackSuccess(respChecker.data)
        } else {
            action && action.callbackError && action.callbackError(respChecker.data)
        }
      
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* restprofilePassword(action: any): any {
    try {
        const data = action.payload;
        let API = UpdateWithVariables(API_URL.USER.PASSWORD_RESET, data.urlParams)
        if (data.urlParams) {
            delete data.urlParams
        }
        const resp = yield call(CallApi.POST, API, data, true);
        let respChecker = responseHandler(resp)
        if (respChecker.status) {
            action && action.callbackSuccess && action.callbackSuccess(respChecker.data)
        } else {
            action && action.callbackError && action.callbackError(respChecker.data)
        }
      
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
 */

